import { INavigationLink } from "../../../../../models";
import { AvisBack } from "../AvisBack";
import { AvisNavigationItem } from "./AvisFormNavigationItem";

interface IAvisFormNavigationProps {
  backLink?: INavigationLink;
  forwardLink?: INavigationLink;
}
export function AvisFormNavigation(props: Readonly<IAvisFormNavigationProps>) {
  const { backLink, forwardLink } = props;

  return (
    <div className="avis-form-navigation grid">
      <div className="avis-form-navigation-left col">
        {backLink && <AvisBack backLink={backLink} />}
      </div>
      <div className="avis-form-navigation-right col">
        {forwardLink && <AvisNavigationItem navLink={forwardLink} />}
      </div>
    </div>
  );
}
